import axios from 'axios'
import router from './router'
import { Message } from 'element-ui'
import store from '@/plugins/vuex'

const admin = axios.create({
  baseURL: process.env.VUE_APP_ADMIN_API_URL,
  timeout: 300000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

const defaultUrl = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

admin.interceptors.request.use(config => {
  let token = localStorage.getItem('token')
  config.headers = Object.assign(
    {
      Authorization: `Bearer ${token}`
    },
    config.headers
  )
  return config
})

admin.interceptors.response.use(
  response => {
    if (
      (response.config.method === 'post' || response.config.method === 'put') &&
      !router.currentRoute.path.includes('/auth/')
    ) {
      if (
        response.config.url.includes('talent-scout/artist') &&
        response.config.method === 'put'
      ) {
        if (response.config.url.includes('/metadata')) {
          Message({
            message: 'Metadata successfully saved.',
            type: 'success'
          })
        } else if (response.config.url.includes('/social')) {
          Message({
            message: 'Social successfully saved.',
            type: 'success'
          })
        }
      } else if(
        response.config.url.includes('talent-scout/label') &&
        (response.config.method === 'post' || response.config.method === 'put')
      ){
        if (response.data.response.status == 200) {
          Message({
            message: 'Data successfully saved.',
            type: 'success'
          })
        }
      }
      else if (response.config.url.includes('/delete')) {
        Message({
          message: 'Data successfully deleted.',
          type: 'success'
        })
      } else {
        if (response.data.success && !response.config.url.includes('logout')) {
          Message({
            message: 'Data successfully saved.',
            type: 'success'
          })
        }
      }
    }
    return response
  },
  error => {
    if (error.config.url.includes('login')) {
      if (
        error.response.data.response &&
        error.response.data.response.message
      ) {
        Message({
          type: 'error',
          message: error.response.data.response.message
        })
      } else {
        Message({
          type: 'error',
          message: error.response.data.message
        })
      }
    } else if (
      error.config.url.includes('talent-scout/artist') &&
      error.config.method === 'put'
    ) {
      if (error.config.url.includes('/metadata')) {
        Message({
          message: 'Error while saving metadata.',
          type: 'error'
        })
      } else if (error.config.url.includes('/social')) {
        Message({
          message: 'Error while saving social.',
          type: 'success'
        })
      }
    } else if (error.response.status == 401) {
      if (store.state.auth.user.user_level == 'label_admin') {
        store.commit('artistDashboard/setSelectedTrack', null)
        store.commit('artistDashboard/setSelectedArtist', null)
        router.push('/')
      } else if (store.state.auth.user.user_level == 'artist_admin') {
        router.push('/')
      } else {
        localStorage.removeItem('token')
        store.commit('auth/setUser', null)
        router.push('/auth/login')
      }
    } else if (error.response.status == 404) {
      Message({
        message: error.response.data.message
          ? error.response.data.message
          :  (error ? error : 'API endpoint does not exist.'),
        type: 'error'
      })
    } else if (error.response.status == 413) {
      Message({
        message: error.response.data.message
          ? error.response.data.message
          :  (error ? error : 'Request Entity Too Large.'),
        type: 'error'
      })
    }else if (error.response.status == 422) {
      for (let [key, value] of Object.entries(error.response.data.errors)) {
        setTimeout(function() {
          Message({
            showClose: true,
            message: value[0],
            type: 'error'
          })
        }, 10)
      }
    }
    else if (error.response.status == 503) {

    } else {
      Message({
        message: 'Error while retreiving or saving data.',
        type: 'error'
      })
    }

    return Promise.reject(error)
  }
)

const artist = axios.create({
  baseURL: process.env.VUE_APP_ARTIST_API_URL,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

artist.interceptors.request.use(config => {
  let token = localStorage.getItem('token')
  config.headers = Object.assign(
    {
      Authorization: `Bearer ${token}`
    },
    config.headers
  )
  return config
})

artist.interceptors.response.use(
  response => {
    if (
      (response.config.method === 'post' || response.config.method === 'put') &&
      !router.currentRoute.path.includes('/auth/')
    ) {
      if (response.config.url.includes('/delete')) {
        Message({
          message: 'Data successfully deleted.',
          type: 'success'
        })
      } else if (response.config.url.includes('myprofile/message') ) {
        //nothing
      } else {
        if (!response.config.url.includes('logout')) {
          Message({
            message: 'Data successfully saved.',
            type: 'success'
          })
        }
      }
    }
    return response
  },
  error => {
    if (error.response.status == 400) {
      Message({
        message: error.response.data.message
            ? error.response.data.message
            : (error ? error : 'Error while retreiving or saving data.'),
        type: 'error'
      })
    }
    else if (error.response.status == 401) {
      localStorage.removeItem('token')
      store.commit('auth/setUser', null)
      router.push('/auth/login')
    }
    else if (error.response.status == 422) {
      Message({
        message: error.response.data.message
            ? error.response.data.message
            : (error ? error : 'Error while retreiving or saving data.'),
        type: 'error'
      })
    }
    else {
      Message({
        message: 'Error while retreiving or saving data.',
        type: 'error'
      })
    }

    return Promise.reject(error)
  }
)

const label = axios.create({
  baseURL: process.env.VUE_APP_LABEL_API_URL,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

label.interceptors.request.use(config => {
  let token = localStorage.getItem('token')
  config.headers = Object.assign(
    {
      Authorization: `Bearer ${token}`
    },
    config.headers
  )
  return config
})

label.interceptors.response.use(
  response => {
    if (
      (response.config.method === 'post' || response.config.method === 'put') &&
      !router.currentRoute.path.includes('/auth/')
    ) {
      if (response.config.url.includes('/delete')) {
        Message({
          message: 'Data successfully deleted.',
          type: 'success'
        })
      } else if (response.config.url.includes('myprofile/message')) {
        //nothing
      } else {
        if (!response.config.url.includes('logout')) {
          Message({
            message: 'Data successfully saved.',
            type: 'success'
          })
        }
      }
    }
    return response
  },
  error => {
    if (error.response.status == 400) {
      Message({
        message: error.response.data.message
            ? error.response.data.message
            : (error ? error : 'Error while retreiving or saving data.'),
        type: 'error'
      })
    }
    else if (error.response.status == 401) {
      store.commit('artistDashboard/setSelectedTrack', null)
      store.commit('artistDashboard/setSelectedArtist', null)
      localStorage.removeItem('token')
      store.commit('auth/setUser', null)
      router.push('/auth/login')
    } else {
      Message({
        message: 'Error while retreiving or saving data.',
        type: 'error'
      })
    }

    return Promise.reject(error)
  }
)

const content = axios.create({
  baseURL: process.env.VUE_APP_CONTENT_API_URL,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

content.interceptors.request.use(config => {
  let token = localStorage.getItem('token')
  config.headers = Object.assign(
    {
      Authorization: `Bearer ${token}`
    },
    config.headers
  )
  return config
})

content.interceptors.response.use(
  response => {
    if (
      (response.config.method === 'post' || response.config.method === 'put') &&
      !router.currentRoute.path.includes('/auth/')
    ) {
      if (response.config.url.includes('/delete')) {
        Message({
          message: 'Data successfully deleted.',
          type: 'success'
        })
      } else {
        if (!response.config.url.includes('logout')) {
          Message({
            message: 'Data successfully saved.',
            type: 'success'
          })
        }
      }
    }
    return response
  },
  error => {
    if (error.response.status == 401) {
      store.commit('artistDashboard/setSelectedTrack', null)
      store.commit('artistDashboard/setSelectedArtist', null)
      localStorage.removeItem('token')
      store.commit('auth/setUser', null)
      router.push('/auth/login')
    } else {
      Message({
        message: 'Error while retreiving or saving data.',
        type: 'error'
      })
    }

    return Promise.reject(error)
  }
)

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(config => {
  let token = localStorage.getItem('token')
  config.headers = Object.assign(
    {
      Authorization: `Bearer ${token}`
    },
    config.headers
  )
  return config
})

api.interceptors.response.use(
  response => {
    if (
      (response.config.method === 'post' || response.config.method === 'put') &&
      !router.currentRoute.path.includes('/auth/')
    ) {
      if (response.config.url.includes('/delete')) {
        Message({
          message: 'Data successfully deleted.',
          type: 'success'
        })
      } else {
        Message({
          message: 'Data successfully saved.',
          type: 'success'
        })
      }
    }
    return response
  },
  error => {
    switch (error.response.status) {
      case 401:
        if (store.state.auth.user.user_level == 'label_admin') {
          store.commit('artistDashboard/setSelectedTrack', null)
          store.commit('artistDashboard/setSelectedArtist', null)
          router.push('/')
        } else if (store.state.auth.user.user_level == 'artist_admin') {
          router.push('/')
        } else {
          localStorage.removeItem('token')
          store.commit('auth/setUser', null)
          router.push('/auth/login')
        }
        break
      case 404:
        Message({
          message: error.response.data.message
            ? error.response.data.message
            :  (error ? error : 'API endpoint does not exist.'),
          type: 'error'
        })
        break
      case 413:
        Message({
          message: error.response.data.message
            ? error.response.data.message
            :  (error ? error : 'Request Entity Too Large.'),
          type: 'error'
        })
        break
      case 422:
        for (let [key, value] of Object.entries(error.response.data.errors)) {
          setTimeout( function () {
            Message({
              showClose: true,
              message: value[0],
              type: 'error'
            })
          }, 10)
        }
        break
      default:
        Message({
          message: 'Error while retreiving or saving data.',
          type: 'error'
        })
        break
    }
    return Promise.reject(error)
  }
)

const front = axios.create({
  baseURL: process.env.VUE_APP_FRONT_URL,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

front.interceptors.request.use(config => {
  let token = localStorage.getItem('token')
  config.headers = Object.assign(
    {
      Authorization: `Bearer ${token}`
    },
    config.headers
  )
  return config
})

front.interceptors.response.use(
  response => {
    if (
      (response.config.method === 'post' || response.config.method === 'put') &&
      !router.currentRoute.path.includes('/auth/')
    ) {
      if (response.config.url.includes('/delete')) {
        Message({
          message: 'Data successfully deleted.',
          type: 'success'
        })
      } else {
        Message({
          message: 'Data successfully saved.',
          type: 'success'
        })
      }
    }
    return response
  },
  error => {
    switch (error.response.status) {
      case 401:
        if (store.state.auth.user.user_level == 'label_admin') {
          store.commit('artistDashboard/setSelectedTrack', null)
          store.commit('artistDashboard/setSelectedArtist', null)
          router.push('/')
        } else if (store.state.auth.user.user_level == 'artist_admin') {
          router.push('/')
        } else {
          localStorage.removeItem('token')
          store.commit('auth/setUser', null)
          router.push('/auth/login')
        }
        break
      case 404:
        Message({
          message: 'API endpoint does not exist.',
          type: 'error'
        })
        break
      case 413:
        Message({
          message: error.response.data.message
            ? error.response.data.message
            :  (error ? error : 'Request Entity Too Large.'),
          type: 'error'
        })
        break
      default:
        Message({
          message: 'Error while retreiving or saving data.',
          type: 'error'
        })
        break
    }
    return Promise.reject(error)
  }
)
const apiBasic = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default { admin, artist, label, content, api, apiBasic, front, defaultUrl }
